var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ListIcon",
      "size": "30"
    }
  }), _vm._v(" Avaliar Desafios ")], 1), _c('h4', {
    staticClass: "mt-1"
  }, [_vm._v("Selecione um desafio para avaliar:")])])], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escola",
      "label-for": "schoolFilter"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "schoolFilter",
      "options": _vm.schoolOptions
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.selectedSchool,
      callback: function callback($$v) {
        _vm.selectedSchool = $$v;
      },
      expression: "selectedSchool"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Desafio",
      "label-for": "challengeFilter"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "challengeFilter",
      "options": _vm.challengeOptions
    },
    on: {
      "change": _vm.filterList
    },
    model: {
      value: _vm.selectedChallenge,
      callback: function callback($$v) {
        _vm.selectedChallenge = $$v;
      },
      expression: "selectedChallenge"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Período",
      "label-for": "dateFilter"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "dateFilter",
      "options": _vm.periodOptions
    },
    on: {
      "change": _vm.onPeriodChange
    },
    model: {
      value: _vm.selectedPeriod,
      callback: function callback($$v) {
        _vm.selectedPeriod = $$v;
      },
      expression: "selectedPeriod"
    }
  })], 1)], 1), _vm.showDatePicker ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial",
      "label-for": "dataInicio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dataInicio",
      "type": "date"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.customDataInicio,
      callback: function callback($$v) {
        _vm.customDataInicio = $$v;
      },
      expression: "customDataInicio"
    }
  })], 1)], 1) : _vm._e(), _vm.showDatePicker ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final",
      "label-for": "dataFim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dataFim",
      "type": "date"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.customDataFim,
      callback: function callback($$v) {
        _vm.customDataFim = $$v;
      },
      expression: "customDataFim"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Pesquisar por aluno"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchQuery,
      callback: function callback($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mb-2 mt-2"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-start",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('span', {
    staticClass: "text-nowrap"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.tableItems.length) + " de " + _vm._s(_vm.totalItems) + " registros ")])]), _c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-end",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('b-pagination', {
    staticClass: "mb-0 mt-1 mt-sm-0",
    attrs: {
      "total-rows": _vm.totalItems,
      "per-page": _vm.perPage,
      "first-number": "",
      "last-number": "",
      "prev-class": "prev-item",
      "next-class": "next-item"
    },
    scopedSlots: _vm._u([{
      key: "prev-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronLeftIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }, {
      key: "next-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronRightIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refUserListTable",
    staticClass: "position-relative",
    staticStyle: {
      "min-height": "50vw"
    },
    attrs: {
      "items": _vm.tableItems,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "sort-by": _vm.sortBy,
      "show-empty": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "empty-text": "No matching records found",
      "sort-desc": _vm.isSortDirDesc
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "text-capitalize",
          attrs: {
            "pill": "",
            "variant": "light-".concat(_vm.resolverStatusVariant(data.item.approved, data.item.feedback))
          }
        }, [_vm._v(" " + _vm._s(_vm.resolveUserStatusText(data.item.approved, data.item.feedback)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: _vm.obterUrlAvaliar(data.item.modelo),
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Avaliar")])], 1)], 1)];
      }
    }])
  })], 1), _c('div', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-start",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('span', {
    staticClass: "text-nowrap"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.tableItems.length) + " de " + _vm._s(_vm.totalItems) + " registros ")])]), _c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-end",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('b-pagination', {
    staticClass: "mb-0 mt-1 mt-sm-0",
    attrs: {
      "total-rows": _vm.totalItems,
      "per-page": _vm.perPage,
      "first-number": "",
      "last-number": "",
      "prev-class": "prev-item",
      "next-class": "next-item"
    },
    scopedSlots: _vm._u([{
      key: "prev-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronLeftIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }, {
      key: "next-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronRightIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }